import styled from "@emotion/styled";

export const ContentSubHeadlineContainer = styled.div`
  ul {
    position: relative;

    padding-inline-start: 10px;
    li {
      &:before {
        position: absolute;
        inset-inline-start: 0;
        content: "•";
      }
    }
  }
`;
